import React from 'react';
import { CircleMarker, Popup } from 'react-leaflet';
import FullscreenMap from '../FullscreenMap';
import { severityColors, vehicleStatusColors, vehicleStatusLabels } from './dashboardShared';
import MapDrawTools from '../map/MapDrawTools';
import MapSearchControl from '../map/MapSearchControl';
import DrawingsLayer from '../map/DrawingsLayer';
import CareMarkers from '../map/CareMarkers';
import BuildingsLayer from '../map/BuildingsLayer';

// Carte plein ecran du tableau de bord de crise
const DashboardFullscreenMap = ({ open, onClose, mapCenter, theme, incidents, careCenters, vehicles, dangerZones, token, drawings = [] }) => (
    <FullscreenMap
        open={open}
        onClose={onClose}
        title={`Carte de situation - Tableau de bord (${new Date().toLocaleString('fr-FR')})`}
        center={mapCenter}
        zoom={13}
        theme={theme}
        layers={[
            {
                id: 'incidents', label: 'Incidents', color: '#ef4444',
                count: incidents.length,
                render: () => incidents.map((incident) => (
                    <CircleMarker key={`fi-${incident.id}`} center={[incident.latitude, incident.longitude]} radius={14}
                        pathOptions={{ color: severityColors[incident.severity], fillColor: severityColors[incident.severity], fillOpacity: 0.65, weight: 2 }}>
                        <Popup><div className="p-1 text-xs"><b>{incident.title}</b><br />{incident.type} - {incident.severity}</div></Popup>
                    </CircleMarker>
                ))
            },
            {
                id: 'care', label: 'Centres CARE', color: '#3b82f6',
                count: careCenters.length,
                render: () => <CareMarkers centers={careCenters} prefix="fcc" />
            },
            {
                id: 'buildings', label: 'Bâtiments (état)', color: '#bd622c',
                render: () => <BuildingsLayer editable={!!token} />
            },
            {
                id: 'vehicles', label: 'Vehicules GPS', color: '#22c55e',
                count: vehicles.filter(v => v.gps_latitude && v.gps_longitude).length,
                render: () => vehicles.filter(v => v.gps_latitude && v.gps_longitude).map((v) => (
                    <CircleMarker key={`fv-${v.id}`} center={[v.gps_latitude, v.gps_longitude]} radius={9}
                        pathOptions={{ color: vehicleStatusColors[v.status] || '#3b82f6', fillColor: vehicleStatusColors[v.status] || '#3b82f6', fillOpacity: 0.9, weight: 2 }}>
                        <Popup><div className="text-xs min-w-[180px]"><b>{v.name}</b><br />{v.type} - {v.plate_number}<br /><span style={{ color: vehicleStatusColors[v.status] }}>{vehicleStatusLabels[v.status] || v.status}</span>{v.current_mission && <><br />{v.current_mission}</>}</div></Popup>
                    </CircleMarker>
                ))
            },
            {
                id: 'zones_signalees', label: 'Zones dangereuses', color: '#ef4444',
                count: dangerZones.filter(z => z.latitude && z.longitude && z.statut === 'signale').length,
                render: () => dangerZones.filter(z => z.latitude && z.longitude && z.statut === 'signale').map(z => (
                    <CircleMarker key={`fdz-${z.id}`} center={[z.latitude, z.longitude]} radius={16}
                        pathOptions={{ color: '#ef4444', fillColor: '#ef4444', fillOpacity: 0.4 }}>
                        <Popup><div className="text-xs"><b>Zone dangereuse</b><br />{z.lieu}<br />{z.description}</div></Popup>
                    </CircleMarker>
                ))
            },
            {
                id: 'zones_securisees', label: 'Zones securisees', color: '#22c55e',
                count: dangerZones.filter(z => z.latitude && z.longitude && z.statut === 'securise').length,
                render: () => dangerZones.filter(z => z.latitude && z.longitude && z.statut === 'securise').map(z => (
                    <CircleMarker key={`fdzs-${z.id}`} center={[z.latitude, z.longitude]} radius={12}
                        pathOptions={{ color: '#22c55e', fillColor: '#22c55e', fillOpacity: 0.3 }}>
                        <Popup><div className="text-xs"><b>Zone securisee</b><br />{z.lieu}</div></Popup>
                    </CircleMarker>
                ))
            },
        ]}
    >
        <MapSearchControl />
        {token ? <MapDrawTools token={token} /> : <DrawingsLayer drawings={drawings} />}
    </FullscreenMap>
);

export default DashboardFullscreenMap;
